import React from 'react'
export default function TestComponent() {
  return (
    <div className='my-4'>This is where the blog will appear</div>
  )
}
